import { Typography } from '@forethought-technologies/forethought-elements';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { EventMessageComponent } from 'api/types';
import React from 'react';
import { RestartChatButton } from './RestartChatButton';

interface Props {
  widgetComponent: EventMessageComponent;
}

export const EventMessage: React.FC<Props> = ({ widgetComponent }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        color: theme.palette.colors.grey[600],
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '16px',
      }}
    >
      <Box
        dir='auto'
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: '8px',
          maxWidth: '80%',
          textAlign: 'center',
        }}
      >
        <Typography variant='font12'>
          {widgetComponent.component_fields.message}
        </Typography>
        {widgetComponent.component_fields.should_show_restart_chat_button && (
          <RestartChatButton />
        )}
      </Box>
    </Box>
  );
};
